import { useAnimation } from "framer-motion";
import { useEffect } from "react";

const useHeroSection = () => {
  const controlsImage1 = useAnimation();
  const controlsImage2 = useAnimation();

  useEffect(() => {
    let isFront = true;
    const swapImages = () => {
      if (isFront) {
        controlsImage1.start("back");
        controlsImage2.start("front");
      } else {
        controlsImage1.start("front");
        controlsImage2.start("back");
      }
      isFront = !isFront;
    };

    // Continue swapping every 5 seconds
    const interval = setInterval(swapImages, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [controlsImage1, controlsImage2]);

  return { controlsImage1, controlsImage2 };
};

export default useHeroSection;
